module.exports = __webpack_public_path__ + "img/team_1.ce3e360c.jpg";